import { request } from "../../../services/api"
import type { BaseApiResponse } from "../../../types/api.ts"
import type {
  ProjectCommissionPatchData,
  ProjectCommissionsParams,
  ProjectCommissionsResponse
} from "./services.types.ts"

const BASE_URL = `/project-management/projects`

const PATHS = {
  getCommissions: (projectId: string) =>
    `${BASE_URL}/${projectId}/commissions/`,
  patchCommission: (projectId: string, id: string) =>
    `${BASE_URL}/${projectId}/commissions/${id}/`
}

export const getProjectCommissions = async ({
  projectId,
  ...params
}: ProjectCommissionsParams) => {
  return request.api.get<ProjectCommissionsResponse, BaseApiResponse<unknown>>(
    PATHS.getCommissions(projectId),
    params
  )
}

export const patchProjectCommission = async (
  projectId: string,
  { id, ...data }: ProjectCommissionPatchData
) => {
  return request.api.patch<
    BaseApiResponse<ProjectCommissionsResponse>,
    BaseApiResponse<unknown>
  >(PATHS.patchCommission(projectId, id), data)
}
